<template>
    <rich-text-page field="termsAndConditions" title="Terms & Conditions">
        <template #description>Shown at lavishlocations.com/terms.</template>
    </rich-text-page>
</template>

<script>
    import RichTextPage from "../components/rich-text-page";

    export default {
        name: "TermsAndConditions",
        components: {RichTextPage},
    }
</script>



// WEBPACK FOOTER //
// src/site-content/TermsAndConditions.vue